import React, { useContext, useEffect, useState } from 'react'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import { getSampleCsvHeadings, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { useCity } from '../../hooks/CompanyConfiguration/useCity'

export default function City() {
  const { getAllCity, deleteManyCity, loading, paginate, updateCity } = useCity()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { city, addNewCity } = useContext(ConfigurationContext)

  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterCity = city
  const [page, setPage] = React.useState(1)
  const redirectUrl = 'GET_ALL_CITY_BY_COMPANY'
  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllCity({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData(redirectUrl)
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
  }

  const tempHeaders = getSampleCsvHeadings(['districtCode', 'cityCode', 'name'])

  const handleSwitchChange = (item) => updateCity({ ...item, active: !item.active, cityId: item._id })

  let tableBody = []

  if (!loading && filterCity.length > 0) {
    tableBody = filterCity.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.name },
        { value: item.cityCode },
        { value: item.region && item.region.name },
        { value: item.zone && item.zone.name },
        { value: item.state && item.state.name },
        { value: item.district && item.district.name },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-city/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage City',
    url: ROUTES.CITY_FORM,
    editUrl: `/edit-city/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'citys',
    sampleName: 'sample_citys',
    sheetName: 'city',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    redirectUrl,
    addData: addNewCity,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Name', 'City Code', 'Region', 'zone', 'state', 'District', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyCity({ cityId: val }, setSelected)}
    />
  )
}
